import {
  Box,
  FormControlLabel,
  FormHelperText,
  Paper,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material'

export type RadioCardOption = {
  value: string
  title: string
  description: string
}

interface RadioCardGroupProps {
  value: string
  onChange: (value: string) => void
  options: RadioCardOption[]
  error?: string
}

export default function RadioCardGroup({
  value,
  onChange,
  options,
  error
}: Readonly<RadioCardGroupProps>) {
  return (
    <>
      <RadioGroup
        value={value}
        onChange={(_, val) => onChange(val)}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 2,
          maxWidth: 1000,
          paddingY: 1
        }}
      >
        {options.map(opt => {
          const selectedColor = value === opt.value ? 'primary.main' : 'divider'
          const borderColor = error ? 'error.main' : selectedColor
          return (
            <Paper
              key={opt.value}
              variant="outlined"
              sx={{
                p: 1,
                cursor: 'pointer',
                borderColor,
                borderWidth: value === opt.value ? 2 : 1,
                maxWidth: 480,
                backgroundColor: value === opt.value ? 'focus.main' : 'transparent'
              }}
              onClick={() => onChange(opt.value)}
            >
              <FormControlLabel
                value={opt.value}
                control={<Radio />}
                label={
                  <Box padding={1} display={'flex'} flexDirection={'column'} gap={1}>
                    <Typography fontWeight="bold">{opt.title}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {opt.description}
                    </Typography>
                  </Box>
                }
                sx={{ m: 0, width: '100%' }}
              />
            </Paper>
          )
        })}
      </RadioGroup>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </>
  )
}
